module.exports = __webpack_public_path__ + "static/media/order.33519497.gif";